export default __webpack_public_path__ + "static/media/x.4aa7ccbe.svg";